angular.module('eStories.promo.model', [])

    .service('PromoModel', [
        'WS',
        '$location',
        '$rootScope',
        '$window',
        function (WS, $location, $rootScope, $window) {
            var model = this;
            model.promoIneligibile = false;

            model.activateHalfOff3MonthsSale = async () => {
                const response = await model.getPromoDetails('D761F29051C6B22042643FEB487CC199',
                    null,
                    true,
                    null);

                if (response && response.responseStatus === "SUCCESS" && !model.promoIneligibile) {
                    model.halfOff3MonthsSaleActive = true;
                    model.promoPackage = response.promotion;
                    model.promoCodeHash = 'D761F29051C6B22042643FEB487CC199';
                    $rootScope.$broadcast('promoDetailsLoaded', response);
                }
            };

            model.parseFailedPromoMessage = function (failMsg) {
                switch (failMsg) {
                    case "PROMO_EXPIRED":
                    case "NEVER_ELIGIBLE":
                        return 'this promotion has ended.';
                    case "USER_HAS_NO_LIVE_SUB":
                        return 'this promotion is not available for eStories members with active subscriptions.';
                    case "USER_HAS_NO_ACTIVE_SUB":
                        return 'this promotion is not available for existing eStories members.';
                    case "USER_HAS_NO_ACTIVE_SUB_WITH_ANY_PROMO":
                        return 'this promotional offer is not available to you because you have an existing promotional offer.';
                    case "USER_HAS_NO_ACTIVE_SUB_WITH_SAME_PROMO":
                        return 'only one promotion per member may be claimed and our records indicate you have accepted this promotion previously.';
                    case "US_ONLY":
                    case "NON_US_ONLY":
                        return 'this promotion is not available in your region.';
                    default:
                        return 'this promotion is not available.';
                }
            };

            model.getPromoDetails = function (promo, planPricingId, eligibility, couponCode) {
                const promoObj = {
                    promoCode: promo,
                    planPricingId: planPricingId ? planPricingId : null,
                    enforceEligibility: eligibility,
                    couponCode: couponCode ? couponCode : null
                };

                // Revert this when we enable the promo paths again
                // return WS.callServer('billing/getPromoDetails', promoObj);
                return new Promise((resolve) => resolve(null));
            };

            model.shouldRunPromo = function () {
                return $window.location.href.indexOf('2cdt') === -1 &&
                    $window.location.href.indexOf('freeaudiobook') === -1 &&
                    $location.search()['offerType'] !== 'freeTrial' &&
                    $window.location.href.indexOf('startnow') === -1
            };

            model.searchPromoParams = async () => {
                if ($location.search()['vip'] === '5AF4DAEA9948B3DD2C78FF717ED72972') {
                    $rootScope.$broadcast('vipSignUp');
                }

                if ($location.path().indexOf('2mo2cdt') > -1) {
                    $rootScope.$broadcast('2mo2cdtSignUp');
                }

                if ($location.search()['promo']) {
                    const response = await model.getPromoDetails(
                        $location.search()['promo'],
                        null,
                        true,
                        null);
                    if (response && response.responseStatus === "SUCCESS" && !model.promoIneligibile) {
                        model.promoPackage = response.promotion;
                        model.promoCodeHash = $location.search()['promo'];
                        $rootScope.$broadcast('promoDetailsLoaded', response);
                    }
                } else {
                    if (model.shouldRunPromo()) {
                        model.activateHalfOff3MonthsSale().then();
                    }
                }
            };

            model.hasPlanPromo = function () {
                return !model.promoIneligibile &&
                    model.promoCodeHash != null &&
                    model.promoPackage != null &&
                    model.promoPackage.billingPromotionType !== "DISCOUNT_OFF_ONE_TIME";
            };

            model.hasCreditPromo = function () {
                return !model.promoIneligibile &&
                    model.promoCodeHash != null &&
                    model.promoPackage != null &&
                    model.promoPackage.billingPromotionType === "DISCOUNT_OFF_ONE_TIME";
            };

            model.clearPromoPackage = function () {
                model.promoPackage = null;
            };

        }]);
